import pinia from "@/stores/index.js";
import { defineStore } from "pinia";

const useAdditionStore = defineStore("addition", {
  state: () => {
    return {
      additions: [],
    };
  },
});

export const storeAddition = useAdditionStore(pinia);
